


















































































import FlightSaleChannel from "@/store/entities/flight/flightSaleChannel";
import { Component, Vue } from "vue-property-decorator";
import AddSalesChannel from "./modals/addSalesChannel.vue";

@Component({
  components: { AddSalesChannel },
})
export default class SalesChannels extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  flightSaleChannels: FlightSaleChannel[] = [];

  created() {
    this.getFlightSaleChannels();
    (this.headers = [
      { text: "ID", align: "start", filterable: false, value: "id" },
      { text: "İsim", value: "name" },
      { text: "İşlemler", value: "transactions" },
    ]),
      (this.mockData = [
        {
          id: "AGENCY",
          name: "Agency",
        },
      ]);

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Tanımlamalar", disabled: true },
      { text: "Satış Kanalları", disabled: true },
    ];
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getFlightSaleChannels() {
    await this.$store.dispatch({
      type: "flightSaleChannel/getFlightSaleChannels",
    });

    this.flightSaleChannels = this.$store.state.flightSaleChannel.list;
  }

  editFlightSaleChannel(item) {
    this.$store.state.flightSaleChannel.editFlightSaleChannel = item;
    this.isOpenModal = true;
  }

  openModal() {
    this.$store.state.flightSaleChannel.editFlightSaleChannel = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getFlightSaleChannels();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
